import React from "react";
import dataDriven from "../../assets/images/icon-data-driven.png";
import fairTransparent from "../../assets/images/icon-fair-transparent.png";
import realRewards from "../../assets/images/icon-real-rewards.png";
import builtFans from "../../assets/images/icon-built-fans.png";
import { Container } from "react-bootstrap";

const benefits = [
    [dataDriven, "DATA-DRIVEN AI", "Powered by millions of data points and advanced AI models for realistic results."],
    [fairTransparent, "FAIR & TRANSPARENT", "Every simulation is based on stats, not opinion. Pure, unbiased competition."],
    [realRewards, "REAL REWARDS", "Win with your picks. Compete on the leaderboard. Earn real prizes."],
    [builtFans, "BUILT FOR FANS", "Whether it's '96 Bulls or '17 Warriors, relive the greatest teams ever."],
];

const Benefits = () => (
    <Container>
    <section className="benefits shell card">
        {benefits.map(([icon, title, description]) => (
            <article key={title}>
                <div className="benefit-icon"><img src={icon} alt="" /></div>
                <div>
                    <strong>{title}</strong>
                    <p>{description}</p>
                </div>
            </article>
        ))}
    </section>
    </Container>
);

export default Benefits;
